import React from 'react';
import { Button, Container, Grid } from '@mui/material'

import { LayoutLoggedArea } from '../../components/Common/LayoutLoggedArea'
import { Title } from '../../components/Common/Title'
import { FormMyAccount } from '../../components/MyAccount/FormMyAccount'
import { useAuth } from '../../providers/AuthProvider'

export const MyAccount = () => {
  const { logout } = useAuth();

  return (
    <LayoutLoggedArea>
      <Container>
        <Grid container spacing={0}>
          <Grid item sm={12} xs={12} mt={2}>
            <Title>Minha conta</Title>
          </Grid>
          <Grid item sm={2} />
          <Grid item sm={8} xs={12}>
            <FormMyAccount />
          </Grid>
          <Grid item sm={2} />
          <Grid item sm={12} xs={12} align="center" mt={2}>
            <Button variant="text" size='small' className="primary--text bold-text" onClick={logout}>
              Sair
            </Button>
          </Grid>
        </Grid>
      </Container>
    </LayoutLoggedArea>
  )
}
